export default "__VITE_ASSET__DA1_dn7l__"